import React from "react";
import PropTypes from "prop-types";
import { NotificacioWarning } from "./Notification";
import LoginFormulari from "./LoginFormulari";
import Peu from "./Peu";
import styles from "./Login.module.css";
import fotoPortada from "../images/portada_cirerer.jpg";
import logoSMC from "../images/logos/logo_smc.png";
import logoFENOCAT from "../images/logos/Fenocat.png";
import logoGeneralitat from "../images/logos/logo_generalitat.png";
import { MISSATGE_SESSIO_BLOQUEJADA } from "../constantsFormularis";

const estilsFotoPortada = {
  backgroundImage: `url(${fotoPortada})`
};

const Login = props => {
  const { authMessage, history, location } = props;
  const hasShownMessage = React.useRef(false);

  React.useEffect(() => {
    const redirectMessage =
      location && location.state ? location.state.redirectMessage : null;
    const message = authMessage || redirectMessage;

    if (!message || hasShownMessage.current) {
      return;
    }

    hasShownMessage.current = true;

    NotificacioWarning(MISSATGE_SESSIO_BLOQUEJADA, message);

    if (location && location.state && location.state.redirectMessage) {
      history.replace({
        pathname: location.pathname,
        search: location.search,
        hash: location.hash,
        state: null
      });
    }
  }, [authMessage, history, location]);

  return (
    <div className={styles.login}>
      <header className={styles.logos}>
        <div className={styles.logoGencat}>
          <img src={logoGeneralitat} alt="Generalitat de Catalunya" />
        </div>
        <div className={styles.logoSMC}>
          <img src={logoSMC} alt="Servei Meteorològic de Catalunya" />
        </div>
        <div className={styles.logoFeno}>
          <h1>
            <img src={logoFENOCAT} alt="Fenocat" />
          </h1>
        </div>
      </header>
      <main className={styles.form}>
        <LoginFormulari {...props} />
      </main>
      <aside className={styles.image} style={estilsFotoPortada} />
      <footer className={styles.footer}>
        <Peu />
      </footer>
    </div>
  );
};

Login.propTypes = {
  authMessage: PropTypes.string,
  history: PropTypes.shape({
    replace: PropTypes.func.isRequired
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string,
    search: PropTypes.string,
    hash: PropTypes.string,
    state: PropTypes.object
  }).isRequired
};

Login.defaultProps = {
  authMessage: null
};

export default Login;
